// IMAGES
// import danteVideo from '@/assets/poster-videos/webms/100-days-of-dante-poster.webm';
// import heart2heartVideo from '@/assets/poster-videos/webms/heart2heart-poster.webm';
// import cloudviewVideo from '@/assets/poster-videos/webms/cloudview-poster.webm';
// import highTierVideo from '@/assets/poster-videos/webms/high-tier-poster.webm';
// // import gnomeVideo from '@/assets/poster-videos/webms/gnome-poster.webm';
// import trofiVideo from '@/assets/poster-videos/webms/trofi-poster.webm';
// import brantonVideo from '@/assets/poster-videos/webms/branton-poster.webm';
import olcVideo from "@/assets/poster-videos/webms/olc-poster.webm";
// import fuzionFlooringVideo from '@/assets/poster-videos/webms/fuzion-flooring-poster.webm';
// import heemanVideo from '@/assets/poster-videos/webms/heeman-poster.webm';
// import fallProtectionVideo from '@/assets/poster-videos/webms/fall-protection-poster.webm';
import mccormickVideo from "@/assets/poster-videos/webms/mccormick-poster.webm";

//Mp4 versions
import danteVideo from "@/assets/poster-videos/100-days-of-dante-poster.mp4";
import heart2heartVideo from "@/assets/poster-videos/heart2heart-poster.mp4";
import cloudviewVideo from "@/assets/poster-videos/cloudview-poster.mp4";
import highTierVideo from "@/assets/poster-videos/high-tier-poster.mp4";
import trofiVideo from "@/assets/poster-videos/trofi-poster.mp4";
import brantonVideo from "@/assets/poster-videos/branton-poster.mp4";
import fuzionFlooringVideo from "@/assets/poster-videos/fuzion-flooring-poster.mp4";
import heemanVideo from "@/assets/poster-videos/heeman-poster.mp4";
import fallProtectionVideo from "@/assets/poster-videos/fall-protection-poster.mp4";
import techAllianceVideo from "@/assets/poster-videos/TechAlliance.mp4";

// Video Poster Images
import trofiVideoPoster from "@/assets/poster-videos/posters/trofi-poster-image.jpg";
import fallProtectionVideoPoster from "@/assets/poster-videos/posters/tradeintradeup-poster-image.jpg";
import highTierVideoPoster from "@/assets/poster-videos/posters/high-tier-poster-image.jpg";
import heemanVideoPoster from "@/assets/poster-videos/posters/heeman-poster-image.jpg";
import heart2heartVideoPoster from "@/assets/poster-videos/posters/heart2heart-poser-image.jpg";
import fuzionFlooringVideoPoster from "@/assets/poster-videos/posters/fuzion-poster-image.jpg";
import cloudviewVideoPoster from "@/assets/poster-videos/posters/cloudview-poster-image.jpg";
import brantonVideoPoster from "@/assets/poster-videos/posters/branton-poster-image.jpg";
import danteVideoPoster from "@/assets/poster-videos/posters/100-dante-poster-image.jpg";
import olcVideoPoster from "@/assets/poster-videos/posters/olc-poster-image.jpg";
import prepackVideoPoster from "@/assets/poster-videos/posters/prepack-poster-image.jpg";
import techAllianceVideoPoster from "@/assets/poster-videos/posters/techalliance-poster-image.jpg";

//Trofi

import trofiImage1 from "@/assets/screens/trofi/login.jpg";
import trofiImage2 from "@/assets/screens/trofi/active-tournament.jpg";
import trofiImage3 from "@/assets/screens/trofi/club-event.jpg";
import trofiImage4 from "@/assets/screens/trofi/recent-stats.jpg";
import trofiImage5 from "@/assets/screens/trofi/school-home.jpg";
import trofiImage6 from "@/assets/screens/trofi/set-up-profile.jpg";
import trofiImage7 from "@/assets/screens/trofi/school-members-home.jpg";
import trofiImage8 from "@/assets/screens/trofi/tournament-details.jpg";
import trofiImage9 from "@/assets/screens/trofi/general-tournament-info.jpg";
import trofiImage10 from "@/assets/screens/trofi/news-announcements.jpg";
import trofiPoster2 from "@/assets/screens/trofi/poster-1.jpg";
import trofiPoster1 from "@/assets/screens/trofi/poster-2.jpg";

// Heeman's
import heemansPoster2 from "@/assets/screens/heemans/poster-1.jpg";
import heemansPoster1 from "@/assets/screens/heemans/poster-2.jpg";
import heemanImage1 from "@/assets/screens/heemans/home-1.jpg";
import heemanImage2 from "@/assets/screens/heemans/giftcards-desktop.jpg";
import heemanImage3 from "@/assets/screens/heemans/showcases.jpg";
import heemanImage4 from "@/assets/screens/heemans/sustainability-widget-desktop.jpg";
import heemanImage5 from "@/assets/screens/heemans/newsletter.jpg";
import heemanImage6 from "@/assets/screens/heemans/trees-shrubs.jpg";
import heemanImage7 from "@/assets/screens/heemans/fresher-tastier.jpg";
import heemanImage8 from "@/assets/screens/heemans/events-mobile.jpg";
import heemanImage9 from "@/assets/screens/heemans/proudly-serving.jpg";
import heemanImage10 from "@/assets/screens/heemans/sustainability-widget-mobile.jpg";
import heemanImage11 from "@/assets/screens/heemans/megamenu.jpg";

// Hi-Tier
import gridImage from "@/assets/screens/high-tier/Image30.jpg";
import gridImage2 from "@/assets/screens/high-tier/Image31.jpg";
import gridImage3 from "@/assets/screens/high-tier/Image32.jpg";
import gridImage4 from "@/assets/screens/high-tier/Image33.jpg";
import gridImage5 from "@/assets/screens/high-tier/Image34.jpg";
import gridImage6 from "@/assets/screens/high-tier/Image35.jpg";
import gridImage7 from "@/assets/screens/high-tier/Image36.jpg";
import highTierBoardPoster from "@/assets/screens/high-tier/high-tier-poster-board.jpg";
import highTierPoster1 from "@/assets/screens/high-tier/poster-1.jpg";
import highTierPoster2 from "@/assets/screens/high-tier/poster-2.jpg";

// Cloudview
import cloudviewImage1 from "@/assets/screens/cloudview/cloudview_drinks-menu.jpg";
import cloudviewImage2 from "@/assets/screens/cloudview/cloudview_flight-status.jpg";
import cloudviewImage3 from "@/assets/screens/cloudview/cloudview_games-menu.jpg";
import cloudviewImage4 from "@/assets/screens/cloudview/cloudview_movie-single.jpg";
import cloudviewImage5 from "@/assets/screens/cloudview/cloudview_music-list.jpg";
import cloudviewImage6 from "@/assets/screens/cloudview/cloudview_music-menu.jpg";
import cloudviewImage7 from "@/assets/screens/cloudview/cloudview_music-single.jpg";
import cloudviewImage8 from "@/assets/screens/cloudview/cloudview_seatbelt.jpg";
import cloudviewImage9 from "@/assets/screens/cloudview/cloudview_service-overlay-1.jpg";
import cloudviewImage10 from "@/assets/screens/cloudview/cloudview_service-overlay-2.jpg";
import cloudviewPoster1 from "@/assets/screens/cloudview/cloudview-poster-1.jpg";
import cloudviewPoster2 from "@/assets/screens/cloudview/cloudview-poster-2.jpg";

// Dante
import danteImage1 from "@/assets/screens/dante/dante-menu.jpg";
import danteImage2 from "@/assets/screens/dante/dante-wrath.jpg";
import danteImage3 from "@/assets/screens/dante/dante-layer.jpg";
import danteImage4 from "@/assets/screens/dante/dante-canto.jpg";
import danteImage5 from "@/assets/screens/dante/dante-canto-menu.jpg";
import danteImage6 from "@/assets/screens/dante/dante-levels.jpg";
// import dantePoster1 from '@/assets/screens/dante/dante-video.webm';
import dantePoster1 from "@/assets/screens/dante/dante-video.mp4";
import dantePoster2 from "@/assets/screens/dante/dante-poster-2.jpg";
import danteVideoFull from "@/assets/screens/dante/dante-full-intro.mp4";

// Branton
// import brantonPoster2 from '@/assets/screens/branton/branton-b-animation.webm';
// import brantonPoster1 from '@/assets/screens/branton/brantonPoster2.webm';
import brantonPoster2 from "@/assets/screens/branton/branton-b-animation.mp4";
import brantonPoster1 from "@/assets/screens/branton/brantonPoster2.mp4";
import brantonImage1 from "@/assets/screens/branton/branton-prepack-preview.jpg";
import brantonImage2 from "@/assets/screens/branton/branton-menu.jpg";
import brantonImage3 from "@/assets/screens/branton/branton-thermostats.jpg";
import brantonImage4 from "@/assets/screens/branton/branton-hero.jpg";
import brantonImage5 from "@/assets/screens/branton/branton-contact.jpg";
import brantonImage6 from "@/assets/screens/branton/branton-universe-case.jpg";
import brantonImage7 from "@/assets/screens/branton/branton-prepack-case.jpg";

// Heart2Heart
// import heart2heartImage1 from '@/assets/screens/heart2heart/h2h-1.svg';
// import heart2heartImage2 from '@/assets/screens/heart2heart/h2h-2.svg';
// import heart2heartImage3 from '@/assets/screens/heart2heart/h2h-3.svg';
// import heart2heartImage4 from '@/assets/screens/heart2heart/h2h-4.svg';

import heart2heartImage1 from "@/assets/screens/heart2heart/heart2heart-poster1.jpg";
import heart2heartImage2 from "@/assets/screens/heart2heart/heart2heart-poster2.jpg";
import heart2heartImage3 from "@/assets/screens/heart2heart/heart2heart-poster3.jpg";
import heart2heartImage4 from "@/assets/screens/heart2heart/heart2heart-poster4.jpg";
import heart2heartPoster1 from "@/assets/screens/heart2heart/poster-1.jpg";
import heart2heartPoster2 from "@/assets/screens/heart2heart/poster-2.jpg";
import heart2heartFullImage1 from "@/assets/screens/heart2heart/h2h-banner.png";
import heart2heartFullImage2 from "@/assets/screens/heart2heart/shirt-1.jpg";
import heart2heartFullImage3 from "@/assets/screens/heart2heart/shirt-2.jpg";
import heart2heartFullImage4 from "@/assets/screens/heart2heart/shirt-3.jpg";
import heart2heartFullImage5 from "@/assets/screens/heart2heart/h2h-character-sheet.jpg";
// import heart2heartFullVideo from '@/assets/screens/heart2heart/heart2heart-campaign-video.webm';
import heart2heartFullVideo from "@/assets/screens/heart2heart/heart2heart-campaign-video.mp4";

//Fuzion
import fuzionPoster1 from "@/assets/screens/fuzion/poster-2.jpg";
import fuzionPoster2 from "@/assets/screens/fuzion/poster-1.jpg";
import fuzionVideo1 from "@/assets/screens/fuzion/fuzion-1.mp4";
import fuzionVideo2 from "@/assets/screens/fuzion/fuzion-2.mp4";
import fuzionVideo3 from "@/assets/screens/fuzion/fuzion-3.mp4";
import fuzionImage1 from "@/assets/screens/fuzion/fuzion-img-1.jpg";
import fuzionImage2 from "@/assets/screens/fuzion/fuzion-img-2.jpg";

// Trade In Trade Up
import tradeInImage3 from "@/assets/screens/tradeintradeup/tradein3.jpg";
import tradeInImage4 from "@/assets/screens/tradeintradeup/tradein4.jpg";
import tradeInImage5 from "@/assets/screens/tradeintradeup/tradein5.jpg";
import tradeInImage7 from "@/assets/screens/tradeintradeup/tradein7.jpg";
import tradeInImageFull1 from "@/assets/screens/tradeintradeup/tradein-full-1.jpg";
import tradeInImageFull2 from "@/assets/screens/tradeintradeup/tradein-full-2.jpg";
import tradeInImageFull3 from "@/assets/screens/tradeintradeup/tradein-full-3.jpg";
import tradeInPosterImage1 from "@/assets/screens/tradeintradeup/poster-1.jpg";
import tradeInPosterImage2 from "@/assets/screens/tradeintradeup/poster-2.jpg";

//Tech Alliance

import techAlliancePoster1 from "@/assets/screens/techalliance/button-animations.mp4";
import techAlliancePoster2 from "@/assets/screens/techalliance/techalliance-poster-1.jpg";
import techAlliancePosterImage1 from "@/assets/screens/techalliance/techalliance-newsletter.jpg";
import techAlliancePosterVideo1 from "@/assets/screens/techalliance/innov.mp4";
import techAlliancePosterVideo2 from "@/assets/screens/techalliance/service-types.mp4";
import techAlliancePosterVideo3 from "@/assets/screens/techalliance/testimonials-video.mp4";
import techAlliancePosterVideo4 from "@/assets/screens/techalliance/form.mp4";

// OLC
import olcPoster1 from "@/assets/screens/olc/poster-2.jpg";
import olcPoster2 from "@/assets/screens/olc/poster-1.jpg";
import olcImage1 from "@/assets/screens/olc/olc-screen-olc-1.jpg";
import olcImage2 from "@/assets/screens/olc/olc-screen-olc-2.jpg";
import olcImage3 from "@/assets/screens/olc/olc-screen-olc-3.jpg";
import olcImage4 from "@/assets/screens/olc/olc-screen-olc-4.jpg";
import olcImage5 from "@/assets/screens/olc/olc-screen-olc-5.jpg";
import olcImage6 from "@/assets/screens/olc/olc-screen-olc-6.jpg";
import olcImage7 from "@/assets/screens/olc/olc-screen-olc-7.jpg";

// Prepack

import prepackImage1 from "@/assets/screens/mccormick/brands.jpg";
import prepackImage2 from "@/assets/screens/mccormick/dashboard.jpg";
import prepackImage3 from "@/assets/screens/mccormick/floor-display.jpg";
import prepackImage5 from "@/assets/screens/mccormick/product-index.jpg";
import prepackPoster1 from "@/assets/screens/mccormick/poster-2.jpg";
import prepackPoster2 from "@/assets/screens/mccormick/poster-1.jpg";

const fuzionFullImages = [
  fuzionVideo1,
  fuzionImage1,
  fuzionVideo2,
  fuzionImage2,
  fuzionVideo3,
];

const highTierImages = [
  gridImage,
  gridImage2,
  gridImage3,
  gridImage4,
  gridImage5,
  gridImage6,
  gridImage7,
];

const prepackFullImages = [
  prepackImage1,
  prepackImage2,
  prepackImage3,
  prepackImage5,
];

const trofiImages = [
  trofiImage1,
  trofiImage2,
  trofiImage3,
  trofiImage4,
  trofiImage5,
  trofiImage6,
  trofiImage7,
  trofiImage8,
  trofiImage9,
  trofiImage10,
];

const heemanImages = [
  heemanImage1,
  heemanImage2,
  heemanImage3,
  heemanImage4,
  heemanImage10,
  heemanImage11,

  heemanImage5,
  heemanImage6,
  heemanImage7,
  heemanImage8,
  heemanImage9,
];

const cloudviewImages = [
  cloudviewImage1,
  cloudviewImage2,
  cloudviewImage3,
  cloudviewImage4,
  cloudviewImage5,
  cloudviewImage6,
  cloudviewImage7,
  cloudviewImage8,
  cloudviewImage9,
  cloudviewImage10,
];

const danteImages = [
  danteImage1,
  danteImage2,
  danteImage3,
  danteImage4,
  danteImage5,
  danteImage6,
];

const brantonImages = [
  brantonImage1,
  brantonImage6,
  brantonImage3,
  brantonImage2,
  brantonImage4,
  brantonImage5,

  brantonImage7,
];

const heart2heartImages = [
  heart2heartImage1,
  heart2heartImage2,
  heart2heartImage3,
  heart2heartImage4,
];

const heart2heartFullImages = [
  heart2heartFullImage1,
  heart2heartFullImage5,
  heart2heartFullImage2,
  heart2heartFullImage3,
  heart2heartFullImage4,
];

const techAllianceFullImages = [
  techAlliancePosterVideo1,
  techAlliancePosterImage1,

  techAlliancePosterVideo2,
  techAlliancePosterVideo3,
  techAlliancePosterVideo4,
];

const highTierFullImages = [highTierBoardPoster];

const tradeInTradeUpImages = [
  tradeInImage3,
  tradeInImage4,
  tradeInImage5,
  tradeInImage7,
];

const tradeInTradeUpFullImages = [
  tradeInImageFull1,
  tradeInImageFull2,
  tradeInImageFull3,
];

const olcImages = [
  olcImage1,
  olcImage2,
  olcImage3,
  olcImage4,
  olcImage5,
  olcImage6,
  olcImage7,
];

export const trofi = {
  name: "Trofi",
  url: "/projects/trofi",
  type: "Application Development & UI Design",
  roles: ["Creative Director", "Full-Stack Developer", "UI & UX Designer"],
  excerpt:
    "A web application concept for schools to organize and manage their eSport teams and events.",
  posterVideo: trofiVideo,
  posterImage: trofiVideoPoster,
  caseStudy: {
    intro: {
      heading: "Bringing back local community in E-Sports",
      excerpt:
        "An application & service concept to bring schools and students together in the world of e-sports both competitively and socially.",
      video: {
        src: trofiVideo,
        type: "video/webm",
      },
    },
    synopsis: {
      heading: "Trofi",
      texts: [
        "A project concept I started during the beginning of Covid-19. Trofi aims to help bridge schools into the eSport world by providing an easy-to-manage and low-turnover rate platforms for schools to transition into the scene and bring students together with intramural e-Sport events & clubs.",
        "The vision of Trofi would be the bridge for students to socialize, form clubs, and even push those players who want to take it to the next level and go pro.",
      ],
      credits: [
        {
          heading: "Published",
          listing: ["2020"],
        },
        {
          heading: "Type",
          listing: [
            "School Event Portal",
            "Web Application",
            "UI Design",
            "Intramural E-Sports",
          ],
        },
        {
          heading: "Role",
          listing: ["Project Creator", "UI Designer", "Full-Stack Developer"],
        },
      ],
    },
    showcase: {
      heading: "A Platform For Everyone",
      excerpt: `Trofi was built with the idea that any student or teacher, from any level of game experience, whether they are in college or highschool, can participate in events. And for more serious gamers, it offers team management and organization to help them succeed.`,
      image1: {
        src: trofiPoster1,
        alt: "Highschool students playing video games in a tournament.",
      },
      image2: {
        src: trofiPoster2,
        alt: "The Trofi eSport platform banner.",
      },
    },
    imageGrid: {
      headingTitle: "Everything You Need",
      headingTexts: [
        "The Trofi platform aims to be fully inclusive of every tool schools or students may need for social or competitive gaming.",
        `Ranging from news boards, intramural tournaments, local events, team creations, and coaching, Trofi will bring both students and teachers closer in their schools.`,
      ],
      footerTitle: "Designed With Intention",
      footerTexts: [
        `It was designed and architected with the intention of being a platform that can be used by any school, keeping scalability and versatility in mind.`,
      ],
      images: trofiImages,
    },
  },
};

export const heeman = {
  name: `Heeman's`,
  url: "/projects/heemans",
  type: "Website & Event Management System",
  roles: ["Lead Front-End Developer"],
  excerpt:
    "Making the Heeman experience online just as fulfilling as in person. The Heeman website is a hub for all things Heeman, from the latest news, events, and products.",
  posterVideo: heemanVideo,
  posterImage: heemanVideoPoster,
  caseStudy: {
    intro: {
      heading: `Bringing Your Heeman's Digital Experience To Life`,
      excerpt: `Making the Heeman experience online just as fulfilling as in person. The Heeman website is a hub for all things Heeman, from the latest news, events, and products.`,
      video: {
        src: heemanVideo,
        type: "video/webm",
      },
    },
    synopsis: {
      heading: "Heeman's",
      texts: [
        `London, Ontario's most popular garden centre, Heeman's, has been a staple in the community for over 60 years.`,
        `Working with a team of developers, designers, and account managers, we made Heeman's online experience as resourceful as being in-person. The website is a hub for all things Heeman’s, from what's in stock, their cider & meads, to daily events.`,
      ],
      credits: [
        {
          heading: "Published",
          listing: ["2022"],
        },
        {
          heading: "Type",
          listing: ["Website", "Event Management System"],
        },
        {
          heading: "Role",
          listing: ["Lead Front-End Developer"],
        },
        {
          heading: "Website",
          listing: [
            {
              label: "heeman.ca",
              href: "https://heeman.ca",
            },
          ],
        },
      ],
    },
    showcase: {
      heading: `Heeman's is passionate about plants & people! `,
      excerpt: `More than just a garden centre, Heeman's is flowers, flavour and fun! eeman’s provides the best quality product at the best value for your dollar. We are proud growers of all our products, ensuring the best quality and passing our savings on to you.`,
      image1: {
        src: heemansPoster1,
        alt: `Heeman's cold ice cream treats.`,
      },
      image2: {
        src: heemansPoster2,
        alt: `A Heeman's employee.`,
      },
    },
    imageGrid: {
      headingTitle: "Multiple Attractions",
      headingTexts: [
        `With so many different features from Heeman's, there is a wide variety of features across the website.`,
        `From interactive tour maps to eCommerce products, the Heeman website has a wide variety of features to help customers find what they need to prepare for their next visit to Heemans.`,
      ],
      images: heemanImages,
    },
  },
};

export const cloudview = {
  name: "Cloudview",
  url: "/projects/cloudview",
  type: "Flight Service UI & UX Design",
  roles: ["UI & UX Designer"],
  excerpt:
    "Cloudview is an all inclusive entertainment system for British Airways. Users will be able to enjoy numerous streaming entertainments as well as on-board services as their disposal.",
  posterVideo: cloudviewVideo,
  posterImage: cloudviewVideoPoster,
  caseStudy: {
    intro: {
      heading: "Bringing entertainment to your flight experience",
      excerpt:
        "Cloudview is an all inclusive entertainment system for British Airways. Users will be able to enjoy numerous streaming entertainments as well as on-board services as their disposal.",
      video: {
        src: cloudviewVideo,
        type: "video/webm",
      },
    },
    synopsis: {
      heading: "Cloudview",
      texts: [
        `A school project me and two other designers created an experience that all users will be familiar and comfortable using while still maintaining British Airway's style.`,
      ],
      credits: [
        {
          heading: "Published",
          listing: ["2018"],
        },
        {
          heading: "Type",
          listing: ["UI & UX Design", "Entertainment Service"],
        },
        {
          heading: "Role",
          listing: ["Co-Designer"],
        },
      ],
    },
    showcase: {
      heading: "Adaptable For Any Traveler",
      excerpt: `Passengers will be able to experience various streaming services in order to maximize their flight enjoyment. They will be able to browse from 100s of artists and movies. It also offers various video games that people can play at their leisure. Passengers can easily order food or beverages directly through the system.`,
      image1: {
        src: cloudviewPoster1,
        alt: "Cloudview Banner Poster",
      },
      image2: {
        src: cloudviewPoster2,
        alt: "Showing a group of passengers on an airplane.",
      },
    },
    imageGrid: {
      headingTitle: "At Your Convenience",
      headingTexts: [
        "We ensured that all services can be easily accessed. We wanted the user feel empowered with every available feature. We included an easy way for users to track their current flight and customize their experience through seat settings, UI modes, and language.",
      ],
      footerTitle: "Comforting",
      footerTexts: [
        `We wanted to create a theatrical but warming feeling for our users to be cozy and comfortable during their flight. British Airways has had a specific brand guideline that we we required to follow. By combining those two properties we created an interface that was engaging and familiar.`,
      ],
      images: cloudviewImages,
    },
  },
};

export const daysOfDante = {
  name: "100 Days Of Dante",
  url: "/projects/100-days-of-dante",
  type: "Drip Campaign",
  roles: ["Lead Web Development"],
  excerpt:
    "100 Days of Dante is the world's largest dante reading group. A collaborative resource aimed at educating and forming readers of Dante's Divine Comedy.",
  posterVideo: danteVideo,
  posterImage: danteVideoPoster,
  caseStudy: {
    intro: {
      heading: "Study & Journey with Dante's Divine Comedy",
      excerpt: `Brought to you by Baylor's University, 100 Days of Dante is the world's largest Dante reading group. A collaborative resource aimed at educating and forming readers of Dante's Divine Comedy.`,
      video: {
        src: danteVideo,
        type: "video/webm",
      },
    },
    synopsis: {
      heading: "100 Days Of Dante",
      texts: [
        "A 100 day campaign to bring readers together following the journey of Dante as he travels through the Inferno, Purgatorio, and Paradiso.",
        `The classic poem visualized in a way that desceneds the reader into further layers of the poem. 100 Days Of Dante is world's largest reading group`,
        "I helped develop the vision the designer, the client, and myself brought together. We collaborated on the design and then I built the website from the ground up.",
      ],
      credits: [
        {
          heading: "Published",
          listing: ["2021"],
        },
        {
          heading: "Type",
          listing: ["Drip-Campaign", "Web Development", "Creative Development"],
        },
        {
          heading: "Role",
          listing: ["Lead Developer"],
        },
        {
          heading: "Website",
          listing: [
            {
              label: "100daysofdante.com",
              href: "https://100daysofdante.com",
            },
          ],
        },
      ],
    },
    showcase: {
      heading: "Combining modern design with classic literature",
      excerpt: `The website was built and designed with the intention of bringing the reader into the world of Dante. It brings an interactive ecperience while showcasing works of classical art alongside.`,
      image1: {
        src: dantePoster1,
        alt: "A UI demo of the 100 Days of Dante website.",
        mediaType: "video",
        height: 607,
        width: 864,
      },
      image2: {
        src: dantePoster2,
        alt: "An art piece depicting the Wrath layer of Hell. Artwork by Gustave Doré, available at Gutenberg.org.",
        width: 354,
        height: 510,
      },
    },
    fullVideo: danteVideoFull,
    imageGrid: {
      headingTitle: "A True 14th-century epic",
      headingTexts: [
        `The campaign was built to show off both Dante's geography as well as the complete collection of cantos. Offered in both English and its original Italian transcript.`,
      ],
      images: danteImages,
    },
  },
};

export const brantonAgency = {
  name: "Branton Agency",
  url: "/projects/branton",
  type: "Agency Website",
  roles: ["Lead Web Development"],
  excerpt:
    "An agency website built for Branton, a full-service marketing agency that specializes in helping businesses grow.",
  posterVideo: brantonVideo,
  posterImage: brantonVideoPoster,
  caseStudy: {
    intro: {
      heading: "An Agency With Over 30 Years of Experience",
      excerpt: `An agency website built for Branton, a full-service marketing agency that specializes in helping businesses grow.`,
      video: {
        src: brantonVideo,
        type: "video/webm",
      },
    },
    synopsis: {
      heading: "Branton",
      texts: [
        `As a well-established advertising firm in London for over 30 years, Branton Advertising has been providing small businesses and large corporations with marketing and advertising solutions that produce results. We do so by combining our proven approach to design with leading technology know-how.`,
        "I helped design and then build the new agency site for Branton. I worked closely with the team to ensure the site was built to bring their vision to life as well as add my own creative input.",
      ],
      credits: [
        {
          heading: "Published",
          listing: ["2019"],
        },
        {
          heading: "Type",
          listing: ["Website", "Agency Showcase"],
        },
        {
          heading: "Role",
          listing: ["Lead Developer", "Assistant UI Designer"],
        },
        {
          heading: "Website",
          listing: [
            {
              label: "branton.ca",
              href: "https://branton.ca",
            },
          ],
        },
      ],
    },
    showcase: {
      heading: "Re-branding",
      excerpt: `Beyond just the website, Branton went through a full-rebrand which integrated into the website.`,
      image1: {
        src: brantonPoster1,
        alt: "Branton Animated Logo Under Water",
        mediaType: "video",
        height: 607,
        width: 864,
      },
      image2: {
        src: brantonPoster2,
        alt: "Branton Interactive Logo & Agency Process",
        mediaType: "video",
        width: 354,
        height: 510,
      },
    },
    imageGrid: {
      headingTitle: "Showcases",
      headingTexts: [
        "Branton has a wide-range of projects under their belt. Each project is unique and was showcased in a different design.",
      ],
      images: brantonImages,
    },
  },
};

export const heart2heart = {
  name: "Heart2Heart",
  type: "Organ Donor Campaign",
  roles: ["Creative Director"],
  url: "/projects/heart2heart",
  excerpt:
    "A campaign concept to create and promote a campaign to raise awareness and registration for Organ Donation.",
  posterVideo: heart2heartVideo,
  posterImage: heart2heartVideoPoster,
  caseStudy: {
    intro: {
      heading: "Becoming An Organ Donor Only Takes 2 Minutes",
      excerpt: `A campaign concept to create and promote a campaign to raise awareness and registration for Organ Donation.`,
      video: {
        src: heart2heartVideo,
        type: "video/webm",
      },
    },
    fullVideo: heart2heartFullVideo,
    synopsis: {
      heading: "Heart2Heart",
      texts: [
        "Working with Trillium Gift of Life and Lashbrook Marketing & Public Relations, we were tasked to create and promote a campaign to raise awareness and registration for Organ Donation.",
        "With the help of 3 others, I directed the Heart2Heart campaign and managed its video, website, branding, marketing, and creative direction. In addition, I created and managed the back-end side of this project.",
      ],
      credits: [
        {
          heading: "Published",
          listing: ["2017"],
        },
        {
          heading: "Type",
          listing: [
            "Organ Donation Campaign",
            "Video & Animation",
            "Social Media Campaign & Website",
          ],
        },
        {
          heading: "Role",
          listing: [
            "Creative Director",
            "Back-End Developer",
            "Client Management",
          ],
        },
      ],
    },
    showcase: {
      heading: "Spreading the Word",
      excerpt: `Communication through friends and family is often an effective method of spreading information. Our primary goal was to help people pass that initial awkward barrier of talking about more serious subjects. Our campaign encouraged open discussion about organ donation as well as help inform them about the benefits of becoming an organ donor.`,
      image1: {
        src: heart2heartPoster2,
        alt: "A poster showing the Heart2Heart website.",
        height: 607,
        width: 864,
      },
      image2: {
        src: heart2heartPoster1,
        alt: "The different cartoon avatars used in heart2heart branding.",
        width: 354,
        height: 510,
      },
    },
    imageGrid1: {
      headingTitle: "Informative Resources",
      headingTexts: [
        "Helping guide potential donors in the right direction was another core focus of this campaign. All of our campaign materials was made sure to encourage people to our website where they could find out more information.",
        "We made it easy for people to find out the statistics on organ donation as well as the process of becoming a donor.",
      ],
      footerTitle: "Support the Cause",
      footerTexts: [
        `Trying to engage people further than the initial first look can be tricky. The campaign aimed to have donors participate in various competitions and events. We wanted to build a sense of community towards one another. The campaign offered various ways of getting free Heart2Heart mechandise when signing up.`,
      ],
      images: heart2heartImages,
    },
    imageGrid2: {
      images: heart2heartFullImages,
    },
  },
};

export const highTier = {
  name: "High-Tier",
  type: "Web Application",
  url: "/projects/high-tier",
  excerpt:
    "High-Tier is a service for users to quickly find locally sourced high end clothing from their favourite brands and designers.",
  posterVideo: highTierVideo,
  posterImage: highTierVideoPoster,
  caseStudy: {
    intro: {
      heading:
        "A Progressive Web-App To Source & Trade High-End & Designer Clothing",
      excerpt: `High-Tier is a service for users to quickly find locally sourced high end clothing from their favourite brands and designers.`,
      video: {
        src: highTierVideo,
        type: "video/webm",
      },
    },
    synopsis: {
      heading: "High-Tier",
      texts: [
        "A Full-Stack project I created for my thesis project in College. An online marketplace for users to buy and sell high-end clothing. It sources local profiles in your area and finds clothing in your sizes, providing a style matching system similar to modern dating apps.",
      ],
      credits: [
        {
          heading: "Published",
          listing: ["2018"],
        },
        {
          heading: "Type",
          listing: [
            "Web Application",
            "Video & Animation",
            "Online Marketplace",
            "School Thesis",
          ],
        },
        {
          heading: "Role",
          listing: ["Full-Stack Developer", "Designer"],
        },
      ],
    },
    showcase: {
      heading: "Explore Locally",
      excerpt: `Search and find sellers or buyers based off your city. The user can search for clothing and sellers based off any specified city. It optimizes geolocation in order to create a more seamless and friendler profile setup to the user.`,
      image1: {
        src: highTierPoster2,
        alt: "A stylish woman in a leather pant-suit holding a designer turquoise bag.",
        height: 607,
        width: 864,
      },
      image2: {
        src: highTierPoster1,
        alt: "A young girl in vibrant sunglasses and a black denim jacket.",
        width: 354,
        height: 510,
      },
    },
    imageGrid: {
      headingTitle: "Personalized Feed",
      headingTexts: [
        `Customize your settings and sort through posts based off your own sizings. The user can insert their clothing meaurements and search clothing in their size at any time. The user has a viewing option to swipe left or right on matched clothing for an easier searching experience.`,
      ],
      images: highTierImages,
    },
    imageFullGrid: {
      images: highTierFullImages,
    },
  },
};

export const fuzionFlooring = {
  name: "Fuzion Flooring Collections",
  type: "Collection Showcase",
  url: "/projects/fuzion-flooring",
  roles: ["Lead Front-End Developer", "Animation Developer"],
  excerpt:
    "A collection of artistry pages for Fuzion Flooring, Canada's premier multi-surface flooring company—with a reputation for high-quality products and expert craftsmanship.",
  posterVideo: fuzionFlooringVideo,
  posterImage: fuzionFlooringVideoPoster,
  caseStudy: {
    intro: {
      heading: `Showcasing Fuzion's beautiful flooring collection`,
      excerpt: `A collection of artistry pages for Fuzion Flooring, Canada's premier multi-surface flooring company—with a reputation for high-quality products and expert craftsmanship.`,
      video: {
        src: fuzionFlooringVideo,
        type: "video/webm",
      },
    },
    synopsis: {
      heading: "Fuzion Flooring",
      texts: [
        `Fuzion's artistry collection pages are designed to be a more modern and engaging experience for the users that represent the high-quality products that Fuzion offer.`,
        "I was tasked with developing the front-end of the pages, as well as bringing animation and interactivity to a static design.",
      ],
      credits: [
        {
          heading: "Published",
          listing: ["2023"],
        },
        {
          heading: "Type",
          listing: ["Website", "Creative Development", "Product Showcase"],
        },
        {
          heading: "Role",
          listing: ["Lead Front-End Developer", "Animation Developer"],
        },
      ],
    },
    showcase: {
      heading: "Sleak & Modern",
      excerpt: `Integrating React & Wordpress together, we offered a seamless experience for the client to maintain the content while offering a fast and reliable website.`,
      image1: {
        src: fuzionPoster1,
        alt: "Cavallina Style from Artistry Herringbone Collection",
        height: 607,
        width: 864,
      },
      image2: {
        src: fuzionPoster2,
        alt: "Estate Style from Artistry Chevron Collection",
        width: 354,
        height: 510,
      },
    },
    imageFullGrid: {
      images: fuzionFullImages,
    },
  },
};

export const tradeInTradeUp = {
  name: "Fall-Protection Trade-In Trade-Up",
  url: "/projects/trade-in-trade-up",
  type: "Rebate Program",
  roles: ["Full-Stack Developer", "UI & UX Designer"],
  excerpt:
    "A program for the customers to trade up and get rebates on high-quality 3M™ DBI-SALA® and 3M™ Protecta® Fall Protection products.",
  posterVideo: fallProtectionVideo,
  posterImage: fallProtectionVideoPoster,
  caseStudy: {
    intro: {
      heading: "Trade in the old for the new Fall Protection products",
      excerpt: `A program for the customers to trade up and get rebates on high-quality 3M™ DBI-SALA® and 3M™ Protecta® Fall Protection products.`,
      video: {
        src: fallProtectionVideo,
        type: "video/webm",
      },
    },
    synopsis: {
      heading: "Fall-Protection Trade-In Trade-Up",
      texts: [
        "Working with Branton, I helped see this project from start to finish. I was tasked with developing the front-end and back-end of the pages, as well as bringing animation and interactivity to a static design.",
        "I maintained the client relationship throughout the project and made sure that the client was trained and able to maintain all customer rebates.",
      ],
      credits: [
        {
          heading: "Published",
          listing: ["2019"],
        },
        {
          heading: "Type",
          listing: ["Rebate Program", "Sales Solution", "Web Application"],
        },
        {
          heading: "Role",
          listing: [
            "Full-Stack Developer",
            "Client Management",
            "UI & UX Designer",
          ],
        },
      ],
    },
    showcase: {
      image1: {
        src: tradeInPosterImage2,
        alt: "A group of construction workers analyzing a building plan",
        height: 607,
        width: 864,
      },
      image2: {
        src: tradeInPosterImage1,
        alt: "A construction worker standing on a high-beam with fall-protection gear attached.",
        width: 354,
        height: 510,
      },
    },
    imageGrid: {
      headingTitle: "An Intuitive Experience",
      headingTexts: [
        "The rebate experience end-to-end is modern and intuitive. The user is guided through the process with a simple and easy to use interface.",
      ],
      footerTitle: "Easy To Monitor",
      footerTexts: [
        `Administrators can easily monitor the progress of the rebate submissions and see the status of each one instantly.`,
      ],
      images: tradeInTradeUpImages,
    },
    imageFullGrid: {
      images: tradeInTradeUpFullImages,
    },
  },
};

export const prepackPlanner = {
  name: `McCormick's Prepack Planner`,
  type: "Inventory Management System",
  url: "/projects/prepack-planner",
  roles: ["Full-Stack Developer"],
  excerpt:
    "A sales solution for McCormick sales and customers to manage their prepack planners, products, spices, and their brands.",
  posterVideo: mccormickVideo,
  posterImage: prepackVideoPoster,
  caseStudy: {
    intro: {
      heading: `Showcasing Thousands Of Displays, Ready To Install`,
      excerpt: `A sales solution for McCormick sales and customers to manage their prepack planners, products, spices, and their brands.`,
      video: {
        src: mccormickVideo,
        type: "video/webm",
      },
    },
    synopsis: {
      heading: "McCormick's Prepack Planner",
      texts: [
        `The Prepack Planner was an inventory system where McCormick could manage and update their entire inventory through individual products, equipment, to full display cases.`,
        `This system would be used both by the team at McCormick as well as third-party vendors who would be installing the displays in stores.`,
        "I was tasked scoping the full project, as well as keepinng the relationship with the client to ensure deliverables were aligned. The system's development was lead by myself and I helped train the client on maintaining the inventory system they still use.",
      ],
      credits: [
        {
          heading: "Published",
          listing: ["2018"],
        },
        {
          heading: "Type",
          listing: [
            "Inventory Management",
            "Client To Customer Fulfillments",
            "CMS Portal",
          ],
        },
        {
          heading: "Role",
          listing: ["Lead Full-Stack Developer", "Client Management"],
        },
      ],
    },
    showcase: {
      heading: "A Full-Ranged Project",
      excerpt: `This was a true full-stack project, ranging from building the UI and UX to building the relational data between products and prepacks. McCormick's team was able to be comfortably taught how to maintain and update all of their products when connecting with retailers.`,
      image1: {
        src: prepackPoster1,
        alt: "Cavallina Style from Artistry Herringbone Collection",
        height: 607,
        width: 864,
      },
      image2: {
        src: prepackPoster2,
        alt: "Estate Style from Artistry Chevron Collection",
        width: 354,
        height: 510,
      },
    },
    imageFullGrid: {
      images: prepackFullImages,
    },
  },
};

export const oxfordLearning = {
  name: `Oxford Learning`,
  type: "Rebrand & Reskin",
  url: "/projects/oxford-learning",
  roles: ["Lead Front-End Developer"],
  excerpt: `A web rebrand & reskin for Oxford Learning. A tutoring service to show your child how to learn effectively by providing learning skills for inside and outside the classroom.`,
  posterVideo: olcVideo,
  posterImage: olcVideoPoster,
  caseStudy: {
    intro: {
      heading: `Head Back To School With Oxford Learning`,
      excerpt: `Oxford Learning is a tutoring service with customized programs designed to move at your child's pace—never too fast or too slow—your child will learn to think actively and critically about the process of learning. Better school confidence leads to better grades in every subject and for every grade.`,
      video: {
        src: olcVideo,
        type: "video/webm",
      },
    },
    synopsis: {
      heading: "Oxford Learning",
      texts: [
        `Oxford Learning wanted to reskin their website and brand to bring in a more playful and colorful experience. I was tasked with developing the front-end of the pages, as well as bringing animation and interactivity to a static design. `,
        "Since the site already had an existing brand and theme, there was a lot of care and attention to detail to ensure the new design was implemented correctly but seamlessly integrated.",
        "I also had to monitor and provide guidance to other junior developers to ensure the project was completed at a professional quality.",
      ],
      credits: [
        {
          heading: "Published",
          listing: ["2022"],
        },
        {
          heading: "Type",
          listing: ["Website Rebrand"],
        },
        {
          heading: "Role",
          listing: ["Lead Front-End Developer"],
        },
        {
          heading: "Website",
          listing: [
            {
              label: "oxfordlearning.com",
              href: "https://www.oxfordlearning.com/",
            },
          ],
        },
      ],
    },
    showcase: {
      heading: "Friendly For All Ages",
      excerpt: `The rebranded design offers a beautiful and welcoming design for parents and children to feel engaged and excited to learn.`,
      image1: {
        src: olcPoster1,
        alt: "Cavallina Style from Artistry Herringbone Collection",
        height: 607,
        width: 864,
      },
      image2: {
        src: olcPoster2,
        alt: "Estate Style from Artistry Chevron Collection",
        width: 354,
        height: 510,
      },
    },
    imageGrid: {
      images: olcImages,
    },
  },
};

export const techAlliance = {
  name: `TechAlliance`,
  type: "Tech Business & Entrepreneurs Website",
  url: "/projects/techalliance",
  roles: ["Lead Front-End Developer"],
  excerpt: `A new modern and animated website for TechAlliance, empowering tech companies and entrepreneurs with free coaching and advisory services to grow Canada's vibrant tech community.`,
  posterVideo: techAllianceVideo,
  posterImage: techAllianceVideoPoster,
  caseStudy: {
    intro: {
      heading: `The Place Where Innovative Venture Thrives`,
      excerpt: `A new modern and animated website for TechAlliance, empowering tech companies and entrepreneurs with free coaching and advisory services to grow Canada's vibrant tech community.`,
      video: {
        src: techAllianceVideo,
        type: "video/webm",
      },
    },
    synopsis: {
      heading: "Tech Alliance",
      texts: [
        "We worked on TechAlliance's new branding to make it much more lively and adaptable to different services and consultations.",
        "I was in charge of all the Front-End development and making sure the client's and designer's vision aligned with the final product. TechAlliance brought many unique challenges due to the versatility of the components.",
        "Myself and another back-end developer were able to build and fully scale the website for various coloured themes, animation styles, and client's content management needs.",
      ],
      credits: [
        {
          heading: "Published",
          listing: ["2023"],
        },
        {
          heading: "Type",
          listing: ["Website", "Web Animations", "Web Development"],
        },
        {
          heading: "Role",
          listing: ["Lead Front-End Developer"],
        },
        {
          heading: "Website",
          listing: [
            {
              label: "techalliance.ca",
              href: "https://www.techalliance.ca/",
            },
          ],
        },
      ],
    },
    showcase: {
      heading: "Beautifully Animated",
      excerpt: `We were given the opportunity to be playful with our animation styles and how we wanted to "blurb" our text bubbles and captions. There is unique animation with how the blurbs are wrapping around the text in a versatile and scalabel manner.`,
      image1: {
        src: techAlliancePoster2,
        alt: "Cavallina Style from Artistry Herringbone Collection",
        height: 607,
        width: 864,
      },
      image2: {
        src: techAlliancePoster1,
        alt: "Estate Style from Artistry Chevron Collection",
        mediaType: "video",
        width: 354,
        height: 510,
      },
    },
    imageFullGrid: {
      images: techAllianceFullImages,
    },
  },
};

const projects = [
  techAlliance,
  trofi,
  fuzionFlooring,
  daysOfDante,
  heeman,
  brantonAgency,
  tradeInTradeUp,
  heart2heart,
  highTier,
  cloudview,
  prepackPlanner,
  oxfordLearning,

  // {
  // 	name: 'Oxford Learning Center',
  // 	type: 'Re-brand',
  // 	roles: ['Lead Front-End Developer'],
  // 	excerpt:
  // 		'Re-branding Oxford Learning Center website and bringing to life a new website.',
  // 	posterVideo: olcVideo,
  // },

  // {
  // 	name: 'Gnome',
  // 	type: 'Arduino Software',
  // 	roles: ['Software Developer', 'UI & UX Designer'],
  // 	excerpt:
  // 		"GNOME is a product used to measure a plant's temperature, moisture and sunlight levels which can be viewed on an app.",
  // 	posterVideo: gnomeVideo,
  // },
  // {
  // 	name: "McCormick's Prepack Planner",
  // 	type: 'Inventory Management System',
  // 	roles: ['Full-Stack Developer'],
  // 	excerpt:
  // 		'A sales solution for McCormick to manage their prepack planners, products, spices, and their brands.',
  // 	posterVideo: mccormickVideo,
  // },
];

export const cta = {
  title: "More Projects",
  text: `A collection of my work bringing brands and creative visions to life, from small
	to large scale. A wide range from interactive Web, to
	Enterprise solutions, to self-made projects.`,
  buttonLabel: "View Projects",
  href: "/projects",
};

export default projects;
